import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-toggle-button", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <div id="content">
                <ux-toggle-button text-on="on" text-off="off" on></ux-toggle-button>
                <ux-toggle-button text-on="on" text-off="off"></ux-toggle-button>
                <ux-toggle-button icon-on="fav-filled" icon-off="fav" on></ux-toggle-button>
                <ux-toggle-button icon-on="fav-filled" icon-off="fav" text-on="on" text-off="off"></ux-toggle-button>
            </div>
        `);
        await page.waitForChanges();
        const el = await page.find("#content");
        await page.find(".ux-toggle-button");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should toggle on and off", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-toggle-button text-on="on" text-off="off" on></ux-toggle-button>
        `);
        await page.waitForChanges();
        const toggle = await page.find("ux-toggle-button");
        await page.waitForChanges();
        expect(toggle).toHaveClass("hydrated");
        await toggle.click();
        await page.waitForChanges();
        expect(toggle).not.toHaveAttribute("on");
        await toggle.click();
        await page.waitForChanges();
        expect(toggle).toHaveAttribute("on");
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-toggle-button text-on="on" text-off="off" on></ux-toggle-button>`);
    });
});
